'use strict';

export default {
  EmptyScript: {
    message0: ' '
  }
};
